import { useEffect } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useGetSalesOrdersQuery } from '../../../store/api/salesApi';
import { useGetCurrentCompanyQuery } from '../../../store/api/companyApi';

function SalesOrdersPrint() {
  const { data, isLoading, error } = useGetSalesOrdersQuery({ limit: 500 });
  const { data: company } = useGetCurrentCompanyQuery();
  const currency = company?.currency || 'USD';

  const formatAmount = (value) => {
    const amount = Number(value || 0);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency , minimumFractionDigits: (typeof company !== 'undefined' ? (company?.currencyDecimals ?? 2) : 2), maximumFractionDigits: (typeof company !== 'undefined' ? (company?.currencyDecimals ?? 2) : 2)}).format(amount);
    } catch {
      return `${currency} ${amount.toFixed((typeof company !== 'undefined' ? (company?.currencyDecimals ?? 2) : 2))}`;
    }
  };

  useEffect(() => {
    if (data?.salesOrders) {
      const t = setTimeout(() => {
        window.print();
      }, 300);
      return () => clearTimeout(t);
    }
  }, [data]);

  if (isLoading) return <Typography>Loading...</Typography>;
  if (error) return <Typography color="error">Error loading sales orders</Typography>;

  const orders = data?.salesOrders || [];

  return (
    <Box
      sx={{
        p: 4,
        maxWidth: 1000,
        m: '0 auto',
        fontSize: 12,
        '@media print': {
          boxShadow: 'none',
          m: 0,
          p: 2,
        },
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        {company?.name || 'Company'} - Sales Orders
      </Typography>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Order No</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Customer</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Order Date</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Sales Type</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            <TableCell sx={{ fontWeight: 600, textAlign: 'right' }}>{`Total (${currency})`}</TableCell>
            <TableCell sx={{ fontWeight: 600, textAlign: 'right' }}>{`Balance (${currency})`}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.length > 0 ? (
            orders.map((order) => (
              <TableRow key={order.id}>
                <TableCell>{order.orderNumber}</TableCell>
                <TableCell>{order.customer?.name || '-'}</TableCell>
                <TableCell>
                  {order.orderDate ? new Date(order.orderDate).toLocaleDateString() : '-'}
                </TableCell>
                <TableCell sx={{ textTransform: 'capitalize' }}>{order.salesType}</TableCell>
                <TableCell sx={{ textTransform: 'capitalize' }}>{order.status}</TableCell>
                <TableCell sx={{ textAlign: 'right' }}>{formatAmount(order.totalAmount)}</TableCell>
                <TableCell sx={{ textAlign: 'right' }}>
                  {Number(order.balanceAmount || 0) > 0 ? formatAmount(order.balanceAmount) : '-'}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} align="center">
                <Typography>No sales orders found.</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
}

export default SalesOrdersPrint;

